import { FaMapMarkerAlt, FaStar } from 'react-icons/fa';
import { getPropertyImage } from '../utils/imageHelper';
import { formatPrice } from '../utils/currencyPreference';
import { SmartMatchBadge } from './SmartMatchBadge';
import { scorePropertyMatch } from '../utils/smartMatchScore';
import './SmartMatchBadge.css';
import '../pages/BookingAssistantPage.css';

const AiAssistantRecommendations = ({ recommendations = [], intent, onBook, compact = false }) => {
  if (!recommendations.length) return null;

  return (
    <div className={`ai-rec-cards${compact ? ' ai-rec-cards--compact' : ''}`}>
      {recommendations.map((property) => {
        const isMeeting = property.bookingType === 'meeting';
        return (
          <article
            key={property.id}
            className={`ai-rec-card${isMeeting ? ' ai-rec-card--meeting' : ''}`}
          >
            <div className="ai-rec-media">
              <img src={getPropertyImage(property)} alt={property.name} loading="lazy" />
            </div>
            <div className="ai-rec-body">
              <div className="ai-rec-title-row">
                <h4>{property.name}</h4>
                {!isMeeting && (
                  <SmartMatchBadge
                    match={
                      property.smartMatch ||
                      (intent ? scorePropertyMatch(property, intent) : null)
                    }
                    compact
                    showReasons={false}
                  />
                )}
                {isMeeting && (
                  <span className="ai-rec-type-badge">
                    {property.isExternal ? 'API Result' : 'Meeting Room'}
                  </span>
                )}
              </div>
              <div className="ai-rec-meta">
                <span>
                  <FaMapMarkerAlt /> {property.city}
                  {property.state ? `, ${property.state}` : ''}
                </span>
                {property.rating ? (
                  <span>
                    <FaStar color="#f59e0b" /> {property.rating}
                  </span>
                ) : null}
                {isMeeting && property.capacity ? (
                  <span>Up to {property.capacity} people</span>
                ) : null}
              </div>
              {isMeeting && property.pricePerHour ? (
                <p className="ai-rec-price">
                  {formatPrice(property.pricePerHour, property.currency)} / hour
                </p>
              ) : property.pricePerNight ? (
                <p className="ai-rec-price">
                  {formatPrice(property.pricePerNight, property.currency)} / night
                </p>
              ) : null}
              {property.reason && <p className="ai-rec-reason">{property.reason}</p>}
              {onBook && (
                <button
                  type="button"
                  className="ai-rec-book"
                  onClick={() => onBook(property, intent)}
                >
                  {isMeeting
                    ? property.isExternal
                      ? 'Open Venue'
                      : 'View & Book'
                    : 'Book Now'}
                </button>
              )}
            </div>
          </article>
        );
      })}
    </div>
  );
};

export default AiAssistantRecommendations;
